import React from 'react'
import ImageIdera from '../../../assets/idera.svg';

function BannerIdera() {
  return (
    <div className="panel-horizontal-content bg-light">
    <div className="panel-horizontal d-flex justify-content-between ">
      <div className="card-body">
        <h2 className="card-title">Adherido a IDERA</h2>
        <p className="card-text">
          Infraestructura de Datos Espaciales de la Republica Argentina
        </p>
        <div className="panel-footer">
          <a className="external text-primary" href="https://www.idera.gob.ar/" target="_blank" rel="noopener noreferrer">
            Visitá IDERA
          </a>
        </div>
      </div>
  
      <img
        src={ImageIdera}
        alt="descripción de imagen"
        className="img-fluid"
        style={{ maxWidth: '150px' }}
      />
    </div>
  </div>
  
  )
}

export default BannerIdera